// extracted by mini-css-extract-plugin
module.exports = {"sitemap":"SiteMap_sitemap__c_Qde"};